import { Card, Button, Space, Typography, Popconfirm, Tag } from "antd";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const { Text, Title } = Typography;

const AttendanceCard = () => {
  const { dashboardData, role } = useSelector((state) => state.dashboards);
  const navigate = useNavigate()
  const { timeIn, timeOut } = dashboardData || {}
  return (
    <Card
      style={{
        borderRadius: 16,
        background: "linear-gradient(135deg, #E9FFF8, #F2FFFB)",
        border: "none",
      }}
      bodyStyle={{ padding: 16 }}
    >
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div>
          <Title level={5} style={{ marginBottom: 4 }}>
            Attendance
          </Title>
          <Text type="secondary">
            Check-In Time: {timeIn && timeOut ? <Tag color="green" bordered={false}>{timeIn} - {timeOut}</Tag> : <Tag color="red" bordered={false}>Shift Not Assign</Tag>}
          </Text>
        </div>

        {dashboardData?.isSignkiosk && <div>
          {!dashboardData?.isPresent ? <Button
            type="primary"
            onClick={() => navigate("/pin-validate")}
            style={{
              backgroundColor: "#22C55E",
              borderRadius: 20,
              border: "none",
            }}
          >
            Check In
          </Button> :
            <Popconfirm
              title="Check Out Staff"
              description="Are you sure you want to check out?"
              okText="Yes"
              cancelText="No"
            >
              <Button
                type="primary"
                style={{
                  borderRadius: 20,
                  border: "none",
                }}
                danger
                onClick={() => navigate("/pin-validate")}
              >
                Check Out
              </Button>
            </Popconfirm>}
        </div>
        }
      </div>

      <Space style={{ marginTop: 16 }} size="middle">
        <Button
        type="primary"
        ghost
          style={{
            borderRadius: 20,
            backgroundColor: dashboardData?.isPresent && "#3F3F46",
            color: dashboardData?.isPresent && "#fff",
            width: 140,
          }}
          onClick={() => navigate("/staff/my-attendance")}
        >
          View Details
        </Button>

        {dashboardData?.isSignkiosk && <Button
          disabled={dashboardData?.isPresent}
          danger
          style={{
            borderRadius: 20,
            width: 140,
          }}
        >
          Mark as Absent
        </Button>}
      </Space>
    </Card>
  );
};

export default AttendanceCard;
